import { useEffect, useRef, useState } from 'react';

interface ITimer {
  timer: number;
  startTimer: (time: number) => void;
  stopTimer: () => void;
  resetTimer: () => void;
}

interface IUseCountDownProps {
  start: number;
}

export const useCountDown = ({ start }: IUseCountDownProps): ITimer => {
  const [timer, setTimer] = useState(start || 0);
  const intervalRef = useRef<ReturnType<typeof setInterval>>();

  const stopTimer = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  const startTimer = (time: number) => {
    setTimer(time);
  };

  const resetTimer = () => {
    setTimer(start);
  };

  useEffect(() => {
    if (timer <= 0) return stopTimer();
    intervalRef.current = setInterval(() => {
      setTimer((t) => t - 1);
    }, 1000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [timer]);

  return { timer, startTimer, stopTimer, resetTimer };
};
